<div class="card step-card flex flex-column">
  <p class="ml-2 mt-2 mb-6 title h1-font-size">
    {{(mode == 'create' ? 'creation.externalApplication' : 'edition.externalApplication') | transloco}}
  </p>

  <form [formGroup]="externalApplicationForm" *ngIf="externalApplicationForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="description">{{'attribute.description' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="description" type="text" formControlName="description" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="url">{{'attribute.url' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="url" type="text" formControlName="url" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.color' | transloco}}</label>
          <p>{{'forms.descriptions.color' | transloco}}</p>
        </div>
        <div class="col-12">
          <div class="col-12 xl:col-4 flex flex-column">
            <label [style.background-color]="externalApplicationForm.get('color').value" class="theme-picker cursor-pointer">
              <input formControlName="color" type="color">
            </label>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label>{{'attribute.icon' | transloco}} (*)</label>
          <p>{{'forms.descriptions.icon' | transloco}}</p>
        </div>
        <div class="col-12">
          <div class="col-12 md:col-4 with-margin-bottom">
            <button pButton pRipple label=" {{'common.choose' | transloco}}"
                    icon="pi pi-upload" class="btn-primary" (click)="dispatchClick()"></button>
            <input #fileUploader type="file" accept="image/*" (change)="fileChangeEvent($event)" style="display:none;"/>
          </div>
          <div class="col-12 md:col-4 with-margin-bottom">
            <div>
              <div *ngIf="!image">
                <label *ngIf="!maxSizeErrorMessage || maxSizeErrorMessage == ''" class="fileName">{{'forms.noImage' | transloco}}</label>
                <label *ngIf="maxSizeErrorMessage && maxSizeErrorMessage != ''" class="errorMessage">{{'forms.maxFileSizeMessage' | transloco}} {{maxSizeErrorMessage}}</label>
              </div>
              <div *ngIf="image">
                <label class="removeFile">
                  <i class="fa fa-times" aria-hidden="true" (click)="removeImage()"></i>
                </label>
                <label class="fileIcon">
                  <img src="{{getIcon()}}" class="mr-3" alt="Uploaded image"/>
                </label>
                <label class="fileName">
                  {{image.name}}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </form>

  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <div></div>
      <p-button label="{{(mode == 'create' ? 'common.create' : 'common.save') | transloco}}"
                styleClass="button-primary" class="mr-2"
                *ngIf="externalApplicationForm" [disabled]="!externalApplicationForm.valid || !isValidFile()"
                [loading]="persistingChanges" (onClick)="persistAssetData()"></p-button>
    </div>
  </div>
</div>
